const SESSION_KEY = 'commerce.rec.session.v1';

function generateSessionId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/** Stable browser session id for recommendation + event correlation. */
export function getOrCreateSessionId(): string {
  if (typeof sessionStorage === 'undefined') {
    return generateSessionId();
  }

  const existing = sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;

  const next = generateSessionId();
  sessionStorage.setItem(SESSION_KEY, next);
  return next;
}
